import PropTypes from 'prop-types';
import './Button.css';
import './NeonButton.css';
import {
  FaTrash,
  FaHome,
  FaPlus,
  FaPlay,
  FaRedo,
  FaChartBar,
  FaUsers,
  FaFolderOpen,
  FaSave,
} from 'react-icons/fa';

const BUTTON_ICONS = {
  home: FaHome,
  addPlayer: FaPlus,
  startGame: FaPlay,
  rematch: FaRedo,
  editPlayers: FaUsers,
  stats: FaChartBar,
  loadSavedGame: FaFolderOpen,
  saveGame: FaSave,
};

const Button = ({
  title = '',
  type,
  handleClick = () => {},
  disabled = false,
  ariaLabel,
}) => {
  const types = (type || '').split(' ');
  const isNeon = types.includes('smallSquare');
  const isDelete = !title;
  const isPrimary = types.some((name) =>
    ['startGame', 'rematch', 'loadSavedGame', 'rollAgain'].includes(name)
  );
  const iconType = types.find((name) => BUTTON_ICONS[name]);
  const Icon = isDelete ? FaTrash : BUTTON_ICONS[iconType];
  const neonClass = isNeon
    ? ` neonButton${
        isDelete
          ? ' neonButton--danger'
          : isPrimary
          ? ' neonButton--primary'
          : ''
      }`
    : '';
  return (
    <button
      className={`Button ${type || ''}${neonClass}`}
      onClick={handleClick}
      disabled={disabled}
      aria-label={ariaLabel || (isDelete ? 'Delete' : undefined)}
    >
      {isNeon ? (
        <>
          {Icon && <Icon className="neonButton__icon" aria-hidden="true" />}
          {title && <span className="neonButton__label">{title}</span>}
        </>
      ) : title ? (
        title
      ) : (
        <FaTrash className="trashIcon" aria-hidden="true" />
      )}
    </button>
  );
};

Button.propTypes = {
  title: PropTypes.string,
  type: PropTypes.string,
  handleClick: PropTypes.func,
  disabled: PropTypes.bool,
  ariaLabel: PropTypes.string,
};

export default Button;
